<template>
  <div class="coupon-page">
      <div class="coupon-section">
          <div class="product-href">
              <textarea v-model="productHref" placeholder="请将要转换的商品链接输入到此处"></textarea>
              <span class="clear" @click="clear">清空</span>
          </div>
          <div class="btn-wrap">
              <button :disabled="false" class="btn orange-btn create-btn" @click="createHref">转换成我的链接</button>
          </div>
          <div style="margin-top: 20px;">
              <good-list :isCoupon="true" :product-list="productList"></good-list>
          </div>
          <div class="coupon-content" :class="successRef?'visable':'hidden'">
              <div class="coupon-tab">
                  <div class="tab-item">
                      <span :class="tabIndex=='1' ? 'active' : ''" @click="tabSelect('1')">短链接</span>
                  </div>
                  <div class="tab-item">
                      <span :class="tabIndex=='2' ? 'active' : ''" @click="tabSelect('2')">二维码</span>
                  </div>
              </div>
              <div class="tab-page">
                  <!-- 短链接page-->
                  <div v-if="tabIndex=='1'">
                      <div class="href-res">
                          <div class="href-res-p">
                              <div class="href-res-c">
                                  <!-- <span class="product-label" space="emsp">攻 略</span> -->
                                  <!-- <rich-span nodes="{{richspan}}"></rich-span> -->
                                  <div class="rich-text" v-html="richText"></div>
                              </div>
                          </div>
                          
                      </div>
                      <div class="flex justify-content gap20">
                          <button style="color:white; width: 150px;" class="btn orange-btn create-btn" @click="handleBack">信息反馈</button>
                          <button style="color:white;width: 150px;" class="btn orange-btn create-btn" @click="copyShortCode">复制</button>
                      </div>
                  </div>
                  <!-- 小程序page-->
                  <div v-if="tabIndex=='2'">
                      <div class="rqcode-wrap">
                          <img @click="handleDownloadImg(rqCode)" :src="rqCode" mode="" />
                      </div>
                      <div style="display: flex; justify-content: center; align-items: center; height: 100px;">
                          <span>（点击下载二维码）</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- <Toast v-if="showToast" :type="type">{{ message }}</Toast> -->
      <feed-back :sku-id="skuId" v-if="visablePop" @close="handleCloseFeedBack"></feed-back>
      <!-- 引入弹出组件 -->
      <!-- <feedback sku-id="{{ skuId }}" wx:if="{{ visablePop }}" bind:close="handleCloseFeedBack"></feedback> -->
    </div>
</template>
<script>
import GoodList from '@/components/list/GoodList.vue'
import { getCoupon } from '@/services/order'
// import utils from '@/utils/utils'
// import Toast from 'vue-weui/components/toast/toast.vue'
import feedBack from '@/components/feedback/index.vue'
import { downloadImg } from '@/services/download'
export default {
  components: {
    // Toast,
    GoodList,
    feedBack,
  },
  data() {
    return {
        tabIndex: '1',
        richText: '',
        productHref: '',
        shortCode: '',
        rqCode: '',
        successRef: false,
        productList: [],
        visablePop: false,
        skuId: ''
    }
  },
  created() {
    this.productHref = this.$route.params.itemId == 'custom' ? '' : this.$route.params.itemId
    if( !this.productHref ) {
        this.getProductInfo()
    }
  },
  methods: {
    getProductInfo() {
        let self = this
        getCoupon({ skuId: this.productHref, onlyGoodsInfo: true }).then(res => {
            self.productList = res.data.goodsInfo
        }).catch(() => {
            
        })
    },
    copyShortCode() {
      navigator.clipboard.writeText(this.shortCode).then(() => {
        this.$showToast({
            type: 'icon',
            toastSuccess: true,
            toastMessage: '复制成功！',
            duration: 3000 
        })
      }).catch(() => {
        this.$showToast({
            type: 'icon',
            toastSuccess: true,
            toastMessage: '复制失败！',
            duration: 3000 
        })
      })
    },
    copyProductUrl() {
        // wx.setClipboardData({
        //     data: this.data.productHref
        // })
    },

    copyProductRich() {
        
        let data = this.richText.replace(/<p.*?>/g,'').replace(/<\/p>/g,'\n').replace(/<a.*?>/g,'').replace(/<br.*?>/g,'').replace(/<span.*?>/g,'').replace(/<\/a>/g,'').replace(/<\/span>/g,'')
        console.log(data)
    },
    clear() {
        this.productHref = ''
        this.successRef = false
        this.richText = ''
        this.rqCode = ''
        this.productList = []
    },
    createHref() {
        let self = this
        // 显示加载数据loading
        this.$showToast({
            type: 'loading',
            toastMessage: '正在加载数据...',
            duration: 2000 
        })
        getCoupon({ skuId: this.productHref }).then(res => {
            self.shortCode = res.data.shortCode
            self.rqCode = res.data.rqCode
            self.richText = res.data.course
            self.successRef = true
            self.productList = res.data.goodsInfo
            // self.showToast = false
        }).catch(() => {
            this.showToast = false
            // console.log(error)
            // this.type = 'icon'
            // this.message = '请输入正确的商品ID'
            // utils.showToast(this)
        })
    },
    /**
     * 切换tab
     */
    tabSelect(index) {
        this.tabIndex = index
    },
    /**
     * 下载图片
     */
    handleDownloadImg(e) {
      downloadImg(e)
    },
    /**信息反馈 */
    handleBack() {
        this.visablePop = true
    },
    handleCloseFeedBack() {
        this.visablePop = false
    }
  }
}
</script>
<style scoped>
.coupon-page {
    padding: var(--len10);
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.05);
    /* height: 100vh; */
}

.product-href {
    display: flex;
    background-color: white;
}

textarea {
    padding: var(--len10);
    flex: 1;
    color: gray;
    height: var(--len80);
}

.clear {
    font-size: var(--len12);
    padding: var(--len10) var(--len20);
    color: gray;
}

.product-label {
    width: var(--len60);
    color: gray;
    line-height: var(--len30);
}

.btn-wrap {
    margin-top: var(--len20);
    /* padding: 0 var(--len10); */
}

.btn-wrap button {
    color: white;
    /* font-size: 14px; */
    /* font-weight: normal; */
    width: 100%;
    border-radius: var(--len5);
}

.coupon-input {
    flex: 1;
    width: 100%;
    height: var(--len30);
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: var(--len5);
    padding-left: var(--len10);
}

.ml10 {
    margin-left: var(--len10) !important;
}

.create-btn[disabled] {
    background-color: #fafafa !important;
    color: rgba(0, 0, 0, 0.18) !important;
}

.product-btn {
    width: var(--len60) !important;
    background-color: var(--primary-color);
    color: white;
    height: var(--len30);
    font-size: var(--len14);
    padding: 0;
    text-align: center;
    line-height: var(--len30);
    margin-left: 0!important;
}

/** tab 样式 */
.coupon-content {
    background-color: white;
    margin-top: var(--len20);
    border-radius: var(--len5);
    height: 28.125rem;
    /* visibility: hidden; */
}

.visibale {
    visibility: visible;
}

.hidden {
    visibility: hidden;
}

.coupon-tab {
    display: flex;
    height: var(--len40);
    line-height: var(--len40);
    border-top: 0.5px solid rgba(0, 0, 0, 0.1);
}

.tab-item {
    flex: 1;
    text-align: center;
}

.tab-item span {
    padding: 4px 0 8px 0;
    border-bottom: 2px solid transparent;
    font-size: var(--len14);
    box-sizing: border-box;
}

.tab-item .active {
    border-color: var(--primary-color);
    color: var(--primary-color) !important;
}

/** tab样式结束 */
.href-res {
    padding: var(--len20);
}

.href-res-c {
    display: flex;
    margin-top: var(--len20);
}

.wd80 {
    width: 90px;
}

.href-input {
    flex: 1;
    width: 100%;
    height: var(--len30);
    /* background-color: rgba(0, 0, 0, 0.1); */
    border-radius: var(--len5);
    padding-left: var(--len10);
}

.rich-text {
    flex: 1;
    width: 100%;
    height: 15.625rem;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: var(--len5);
    padding-left: var(--len10);
    overflow-y: auto;
}

.rqcode-wrap {
    margin-top: var(--len40);
    display: flex;
    justify-content: center;
    align-items: center;
}

.rqcode-wrap img {
    width: 9.6875rem;
    height: 11.25rem;
    /* border: 1px solid #cccccc; */
}
.wx-radio-input{
    display: none;
}
</style>